import React from 'react';

export function AddTransport() {
    return <div>AddTransport</div>;
}
